/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import {message} from 'ant-design-vue'

Vue.use(message)

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================

              {
                path: '',
                name: 'main',
                component: () => import('./views/dashboard/Dashboard.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de controle', url: '/dashboard' },
                    { title: 'Dashboard', active: true},
                  ],
                  pageTitle: 'Painel de Controle',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/dashboard/',
                name: 'home',
                component: () => import('./views/dashboard/Dashboard.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de controle', url: '/dashboard' },
                    { title: 'Dashboard', active: true},
                  ],
                  pageTitle: 'Painel de Controle',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/options/all/',
                name: 'optionsAll',
                props: false,
                component: () => import('./views/options/AllOptions.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Dashboard', url: '/dashboard' },
                    { title: 'Opções', active: true},
                  ],
                  pageTitle: 'Opções',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/coupons/all/',
                name: 'couponsAll',
                props: false,
                component: () => import('./views/coupons/AllCoupons.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Dashboard', url: '/dashboard' },
                    { title: 'Cupons de Descontos', active: true},
                  ],
                  pageTitle: 'Cupons de Descontos',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/account/copyData/',
                name: 'copyData',
                props: false,
                component: () => import('./views/pages/account/copyCompany.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Dashboard', url: '/dashboard' },
                  ],
                  pageTitle: 'Copiar Dados',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/bills/opened/',
                name: 'openedBills',
                props: false,
                component: () => import('./views/bill/OpenedOrders.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Pedidos em tempo real', active : true },
                  ],
                  pageTitle: 'Pedidos',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/bills/delivery/',
                name: 'deliveryBills',
                props: false,
                component: () => import('./views/bill/Delivery.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Pedidos - Delivery / Takeout', active : true },
                  ],
                  pageTitle: 'Pedidos - Delivery / Takeout',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/bills/all/',
                name: 'allBills',
                props: false,
                component: () => import('./views/bill/AllOrders.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Histórico de pedidos', active : true },
                  ],
                  pageTitle: 'Pedidos',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/product/add/',
                name: 'addProductNew',
                props: false,
                component: () => import('./views/product/ManageProduct.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Produto', url: '/product/all' },
                    { title: 'Gerenciamento', url : '/product/all'},
                    { title: 'Adicionar produto', active : true }
                  ],
                  pageTitle: 'Novo Produto',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/product/edit/:productId',
                name: 'editProduct',
                props: true,
                component: () => import('./views/product/ManageProduct.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Produto', url: '/product/all' },
                    { title: 'Gerenciamento', url : '/product/all'},
                    { title: 'Editar produto', active : true }
                  ],
                  pageTitle: 'Editar Produto',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/product/organize/',
                name: 'organize',
                props: false,
                component: () => import('./views/product/Organize.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Produtos', url: '/product/all' },
                    { title: 'Organizar', active : true }
                  ],
                  pageTitle: 'Organizar Produtos',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              // {
              //   path: '/product/edit/:id',
              //   name: 'editProduct',
              //   props: true,
              //   component: () => import('./views/product/EditProductFrm.vue'),
              //   meta : {
              //     breadcrumb: [
              //       { title: 'Painel de Controle', url: '/dashboard' },
              //       { title: 'Produto', url: '/product/all' },
              //       { title: 'Gerenciamento', url : '/product/all'},
              //       { title: 'Editar produto', active : true }
              //     ],
              //     pageTitle: 'Editar Produto',
              //     requiredAuth : true,
              //     requiredFullCompanyData : true
              //   }
              // },
              {
                path: '/product/all',
                name: 'allProducts',
                component: () => import('./views/product/AllProducts.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Produto' },
                    { title: 'Gerenciamento', active : true},
                  ],
                  pageTitle: 'Gerenciamento de Produtos',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/table/all',
                name: 'allTables',
                component : () => import('./views/table/AllTables.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Mesas', active : true},
                  ],
                  pageTitle: 'Gerenciamento de Mesas',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/kitchen/orders',
                name: 'kitchenOrders',
                component : () => import('./views/kitchen/AllOrders.vue'),
                meta : {
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/kitchen/settings',
                name: 'kitchenSettings',
                component : () => import('./views/kitchen/Settings.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Cozinha'},
                    { title: 'Configurações', active : true},
                  ],
                  pageTitle: 'Cozinha',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/cashier/fiscal',
                name: 'fiscalDocuments',
                component : () => import('./views/cashier/FiscalDocuments.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Caixa'},
                    { title: 'Notas Fiscais', active : true},
                  ],
                  pageTitle: 'Notas Fiscais',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/cashier/fiscalReport',
                name: 'fiscalReports',
                component : () => import('./views/cashier/FiscalReport.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Caixa'},
                    { title: 'Relatório de Notas Fiscais', active : true},
                  ],
                  pageTitle: 'Relatório de Notas Fiscais',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/accountSettings/:tab',
                name: 'accountSettings',
                props: true,
                component : () => import('./views/pages/account/myAccount.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Minha conta', active: true},
                  ],
                  pageTitle: 'Minha conta',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/reports/taxes',
                name: 'reportsTaxes',
                component : () => import('./views/reports/Taxes.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Relatórios', active: false},
                    { title: 'Taxas', active: true},
                  ],
                  pageTitle: 'Relatório de Taxas',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/reports/ratings',
                name: 'reportsRatings',
                component : () => import('./views/reports/ratings/Ratings'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Relatórios', active: false},
                    { title: 'Avaliações', active: true},
                  ],
                  pageTitle: 'Relatório de Avaliações',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/reports/closing',
                name: 'reportsClosing',
                component : () => import('./views/reports/Closing.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Relatórios', active: false},
                    { title: 'Fechamento Diário', active: true},
                  ],
                  pageTitle: 'Relatório de fechamento',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },
              {
                path: '/reports/period/daily',
                name: 'reportsPeriodDaily',
                component : () => import('./views/reports/period/Daily.vue'),
                meta : {
                  breadcrumb: [
                    { title: 'Painel de Controle', url: '/dashboard' },
                    { title: 'Relatórios', active: false},
                    { title: 'Por Período', active: false},
                    { title: 'Diário', active: true},
                  ],
                  pageTitle: 'Relatório por período: diário',
                  requiredAuth : true,
                  requiredFullCompanyData : true
                }
              },

              {
                path: '/teste/',
                name: 'teste-teste',
                props: false,
                component: () => import('@/views/teste/Teste'),
              },
              
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/invitation/:companyId/:invitationId',
                name: 'page-invite',
                props: true,
                component: () => import('@/views/pages/invite/Invitation.vue'),
              },
              {
                path: '/invitation/:companyId',
                name: 'self-invite',
                props: true,
                component: () => import('@/views/pages/invite/SelfInvitation.vue'),
              },
              {
                path: '/waiting-room/:companyId',
                name: 'waiting-room',
                props: true,
                component: () => import('@/views/pages/invite/WaitingRoom.vue'),
                meta: {
                  requiredAuth : true,
                }
              },
              {
                path: '/companySelect/:forceSelect',
                props: true,
                name: 'page-company-selector',
                component: () => import('@/views/pages/companySelector/AvailableCompanies.vue'),
                meta : {
                  requiredFullCompanyData : false
                }
              },
              {
                path: '/companyCreate',
                name: 'page-company-create',
                component: () => import('@/views/pages/companySelector/CreateCompany.vue'),
                meta : {
                  requiredFullCompanyData : false
                }
              },
              {
                path: '/',
                name: 'page-login',
                component: () => import('@/views/pages/login/Login.vue'),
                meta : {
                  requiredFullCompanyData : false
                }
              },
              {
                path: '/newCompany',
                name: 'page-new-company',
                component: () => import('@/views/pages/register/NewCompanyWizard.vue'),
                meta : {
                  requiredFullCompanyData : false
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.beforeEach(async (to, from, next) => {
  const requiredAuth = to.matched.some(record => record.meta.requiredAuth);
  const isUserLoggedin = store.getters.isUserLoggedIn;
  const requiredFullCompanyData = to.matched.some(record => record.meta.requiredFullCompanyData)

  if(requiredAuth && !isUserLoggedin) {
    store.commit('SET_PAGE_INTENT_AFTER_LOGIN', to);
    router.push({name: 'page-login'})
  }
  next();
  if(requiredFullCompanyData){
    // let isFieldsOk = isAllReqCompanyDataFilled();
    if(store.state.system.flashMessage) {
      message.error(store.state.system.flashMessage, 5);
      store.dispatch('flashMessage','')
    }
  }
    
})

router.afterEach((to, from, next) => {
  const requiredFullCompanyData = to.matched.some(record => record.meta.requiredFullCompanyData)

  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
      appLoading.style.display = "none";
  }

  Vue.nextTick(() => {
      document.title = to.meta.pageTitle || 'Pedido Rápido - O seu restaurante do futuro, agora.';
  });

  /** 
  * Check whether router need to have all company data filled
  * If fields are not filled, it will be redirect to the
  * respective account tab information
  */
  if(requiredFullCompanyData){
    let isFieldsOk = isAllReqCompanyDataFilled();
    if(to.name != 'accountSettings' && typeof(isFieldsOk) == 'number') {
      router.push(`/accountSettings/${isFieldsOk}`)
    }
  }
})

const isAllReqCompanyDataFilled = () => {
  if(!isLoginBasicDataFilled()) {
    store.dispatch('flashMessage', 'Preencha os dados obrigatórios na aba "Pessoal" antes de continuar')
    return 0
  }
  if (!isCompanyBasicDataFilled()) {
    store.dispatch('flashMessage', 'Preencha os dados obrigatórios na aba "Empresa" antes de continuar')
    return 2
  }

  return true
}

const isLoginBasicDataFilled = () => {
  let user = store.state.AppActiveUser

  if(!user.name) return false
  // if(!user.cpf) return false
  // if(!user.phone) return false

  return true
}

const isCompanyBasicDataFilled = () => {
  let company = store.state.AppActiveCompany

  if (!company.name) return false
  if (!company.fiscal.razaoSocial) return false
  if (!company.fiscal.endereco.logradouro) return false
  if (!company.fiscal.endereco.bairro) return false
  if (!company.fiscal.endereco.municipio) return false
  if (!company.fiscal.cnpj) return false
  if (!company.fiscal.inscricaoEstadual) return false

  return true
}


export default router
